import script from "./ProductImageContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductImageContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ProductImageContainer.vue?vue&type=style&index=0&id=7369867e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7369867e"]])

export default __exports__